module.exports = __webpack_public_path__ + "img/layouts.62b42ed3.svg";